import type { InjectionKey, Ref } from 'vue'

export interface MenuTreeBulkContext {
  collapseSignal: Ref<number>
  expandSignal: Ref<number>
  suppressRouteExpansion: Ref<boolean>
}

export const MenuTreeBulkKey: InjectionKey<MenuTreeBulkContext> = Symbol('menu-tree-bulk')
